export type IconType =
	| "add"
	| "at"
	| "background"
	| "badge"
	| "challenge"
	| "chat"
	| "close"
	| "copy"
	| "delete"
	| "down"
	| "event"
	| "fire"
	| "flag"
	| "friends"
	| "hash"
	| "heart"
	| "info"
	| "leaderboard"
	| "left"
	| "list"
	| "loading"
	| "menu"
	| "more"
	| "note"
	| "notification"
	| "photo"
	| "post"
	| "profile"
	| "reaction"
	| "reply"
	| "right"
	| "search"
	| "settings"
	| "share"
	| "snooze"
	| "star"
	| "thumbdown"
	| "thumbup"
	| "tick"
	| "trajectory"
	| "up";

export function Icon({
	icon,
	title,
	mods = "",
}: {
	icon: IconType; // e.g. "rocket"
	title?: string | undefined; // e.g. "Launch!"
	mods?: string | undefined;
}): React.ReactElement {
	return (
		<svg className={`icon ${mods}`}>
			{title ? <title>{title}</title> : null}
			<use href={`/icons.svg#${icon}`} />
		</svg>
	);
}

/** Value that can be turned into an `<Icon>` by `toIcon()` */
export type PossibleIcon = React.ReactElement | string;
export type PossibleOptionalIcon = PossibleIcon | null;

export const LOADING_ICON = <Icon icon="loading" title="Loading..." />;
